// Very similar to ArchiveFilters.js
// But these call AJAX and then inject, the others simply "go-to"

import axios                   from 'axios';
import { dispatchWindowEvent } from './Utils';

class SidebarFilters
{
    constructor ()
    {

        this.dropdownContainers = document.querySelectorAll( '.sidebar .taxonomy-dropdown' );
        // console.log( 'this.dropdownContainers', this.dropdownContainers );

        if ( this.dropdownContainers.length < 1 )
        {
            return;
        }

        this.sidebar = document.querySelector( '.sidebar' );

        this.selects      = this.sidebar.querySelectorAll( '.taxonomy-dropdown select' );
        this.selectsArray = Array.from( this.selects );

        this.postsContainer = document.querySelector( '.sidebar .found-posts' );
        if ( !this.postsContainer )
        {
            // IDK where I'd stick them
            return;
        }
        this.omitIds = parseInt( this.postsContainer.dataset.omitPostId );

        this.memorizeFilters();
        this.compileAllFilters();
        this.bindEvents();

        this.makeDropdownsPretty();

    }

    bindEvents ()
    {


        $( this.selects ).on( 'change', ( event ) =>
        {
            this.getFilteredPosts( event.target );
        } );
    }


    memorizeFilters ()
    {
        this.dropdownThemes = this.selectsArray.find( sel => sel.name === 'taxonomy-themes[]' );
        this.dropdownTypes  = this.selectsArray.find( sel => sel.name === 'taxonomy-types[]' );
        this.dropdownOrder  = this.selectsArray.find( sel => sel.name === 'taxonomy-sort-order[]' );


        this.audience = this.dropdownOrder
            ? (this.dropdownOrder?.dataset?.audience ?? 'jeunes')
            : 'jeunes';


    }

    compileAllFilters ()
    {
        this.themeId = this.dropdownThemes?.value ?? '';
        this.typeId  = this.dropdownTypes?.value ?? '';
        this.order   = this.dropdownOrder?.value ?? 'date';

        // console.log( '[SidebarFilters] Initial filters are   themes = ' + this.themeId + '  types = ' + this.typeId );
    }

    makeDropdownsPretty ()
    {

        let selectOptions = {
            minimumResultsForSearch : Infinity,
        };

        Array.from( this.selects ).forEach( sel =>
        {

            const $sel    = $( sel );
            const $parent = $sel.parent();

            selectOptions.dropdownParent = $parent;


            $sel.select2( selectOptions );
        } )
    }


    async getFilteredPosts ()
    {

        this.compileAllFilters();

        this.postsContainer.innerHTML = '<span class="ajax-loader on-the-left"></span>';
        this.sidebar.classList.add( 'ajaxing' );

        try
        {

            let queryString = new URLSearchParams( {
                themeIds : this.themeId,
                typeIds  : this.typeId,
                omitIds  : this.omitIds,
                sortType : this.order,
                audience : this.audience,
            } ).toString();

            let response = await axios.get( `/endpoints/nouvelles?${queryString}` );

            this.postsContainer.innerHTML = response.data;

            dispatchWindowEvent( 'sidebar-posts-changed', { postsContainer : this.postsContainer } );

            let linkShowMore = document.querySelector( "#sidebar-show-more-filtered" );
            let strUrl       = linkShowMore.getAttribute( "href" );
            const url        = new URL( strUrl );

            queryString = new URLSearchParams( {
                thematiques : this.themeId,
                types       : this.typeId,
                tri         : this.order,
                audience    : this.audience,
            } ).toString();

            url.search = queryString;
            strUrl     = url.toString();

            console.log( "strURL", strUrl );
            linkShowMore.setAttribute( "href", strUrl );

        }
        catch (e)
        {
            console.error( '[SidebarFilters] Something weird happened when trying to get filtered posts', e );
        }

        this.sidebar.classList.remove( 'ajaxing' );
    }
}


const sidebarFilters = new SidebarFilters();
